import { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";
import { MessageCircle, CheckCircle2, AlertCircle } from "lucide-react";

export function AdminWhatsapp() {
  const [status, setStatus] = useState(null);
  const [to, setTo] = useState("");
  const [text, setText] = useState("Olá! Testando integração GIRO+SAÚDE com WhatsApp Business.");
  const [sending, setSending] = useState(false);
  const load = ()=>api.get("/admin/whatsapp/status").then(r=>setStatus(r.data));
  useEffect(() => { load(); }, []);

  const send = async () => {
    setSending(true);
    try {
      await api.post("/admin/whatsapp/send",{to: to.replace(/\D/g,""), text});
      toast.success("Mensagem enviada");
      load();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setSending(false); }
  };

  if (!status) return <Card className="p-6 gs-shadow">Carregando…</Card>;
  const configured = status.configured;

  return (
    <div className="space-y-4" data-testid="admin-whatsapp">
      <Card className={`p-5 gs-shadow border-l-4 ${configured?"border-l-[#0D7C66]":"border-l-amber-500"}`}>
        <div className="flex items-center gap-3">
          {configured
            ? <CheckCircle2 className="w-6 h-6 text-[#0D7C66]"/>
            : <AlertCircle className="w-6 h-6 text-amber-600"/>}
          <div>
            <div className="font-bold">{configured ? "WhatsApp Business ativo" : "WhatsApp Business não configurado"}</div>
            <div className="text-sm text-slate-600">
              {configured
                ? <>Phone Number ID: <b>{status.phone_number_id}</b> • Total de mensagens: <b>{status.total_messages}</b></>
                : "Preencha WHATSAPP_ACCESS_TOKEN, WHATSAPP_PHONE_NUMBER_ID e WHATSAPP_BUSINESS_ACCOUNT_ID em backend/.env"}
            </div>
          </div>
        </div>
        <div className="mt-4 rounded-xl bg-slate-50 p-3 text-xs text-slate-600">
          <div><b>Webhook URL:</b> https://health-connect-dev-2.preview.emergentagent.com/api/whatsapp/webhook</div>
          <div><b>Verify Token:</b> {status.verify_token_hint || "—"}</div>
          <div className="mt-1">Configure isso no Meta App Dashboard → WhatsApp → Configuration → Webhook e inscreva o campo <code>messages</code>.</div>
        </div>
      </Card>

      <Card className="p-5 gs-shadow">
        <div className="font-bold mb-3 flex items-center gap-2"><MessageCircle className="w-5 h-5 text-[#25D366]"/>Enviar mensagem (janela de 24h ou template)</div>
        <div className="grid gap-3 sm:grid-cols-[220px,1fr,auto]">
          <Input data-testid="wa-to" placeholder="Ex: 5513988720803" value={to} onChange={e=>setTo(e.target.value)}/>
          <Textarea data-testid="wa-text" rows={2} value={text} onChange={e=>setText(e.target.value)}/>
          <Button data-testid="wa-send" onClick={send} disabled={!configured || !to || sending} className="bg-[#25D366] hover:bg-[#1eb856] text-white">{sending?"Enviando...":"Enviar"}</Button>
        </div>
        <p className="text-xs text-slate-500 mt-2">Fora da janela de 24h, use templates aprovados no WhatsApp Manager.</p>
      </Card>

      <Card className="p-5 gs-shadow">
        <div className="font-bold mb-3">Últimas mensagens do bot</div>
        {status.recent.length === 0 && <div className="text-sm text-slate-500">Nenhuma mensagem recebida ainda.</div>}
        <div className="space-y-2">
          {status.recent.map(m=>(
            <div key={m.id} className={`rounded-xl p-3 text-sm border ${m.direction==="out"?"bg-[#E6F4F1] border-[#0D7C66]/20 ml-8":"bg-slate-50 border-slate-200 mr-8"}`}>
              <div className="text-xs text-slate-500 mb-0.5">
                {m.direction==="out" ? <>➡ para {m.to}</> : <>⬅ de {m.from}</>} • {new Date(m.sent_at||m.received_at).toLocaleString("pt-BR")}
              </div>
              <div className="whitespace-pre-line">{m.text}</div>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}
